export default {
    type: 'widget',
    config: {
        defaultWidth: 80,
        icon: 'user'
    },
    default: {},
    unique: [],
    sort: 'duration',
    lang: {
        name: 'Official Player Count',
        views: ['sheet'],
        category: 'Game',
        description: 'Publisher set player count for the game.'
    },
    filters: ['official.count']
}